module.exports = __webpack_public_path__ + "media/images/front/icon_favorite_off-0aba3365bf9808b1017b79b4e051e774.png";